import React from "react";
import { Box, Grid } from "@mui/material";
import ExploreCardSkeleton from "./ExploreCardSkeleton";

// DiscoverFeedSkeleton — the ROUTE-LEVEL loading affordance for /discover
// (LOADER-STUTTER fix, ISP-9999, Gordon 2026-08-23).
//
// WHY THIS EXISTS: /discover's route chunk used to load behind routes.js's shared
// <BrandWheelLoader variant="fullpage"> Suspense fallback — a full-screen brand
// WHEEL. The instant the chunk resolved, ExploreV2Page mounted and replaced that
// wheel with its OWN data-loading state, which is a grid of gray card SKELETONS
// (ExploreCardSkeleton). So a single navigation showed: full-page WHEEL ->
// discarded -> skeleton grid -> content. That wheel->skeleton SWAP is the core
// perceived stutter Gordon reported (audit: qa-notes/LOADER-STUTTER-AUDIT.md).
//
// THE FIX: /discover now suspends to THIS skeleton (the SAME ExploreCardSkeleton
// shells the page itself renders while its first data page is in flight) instead
// of to the fullpage wheel. So the sequence becomes: skeleton grid (chunk load)
// -> skeleton grid (data load) -> content — ONE continuous skeleton affordance,
// never a wheel that gets thrown away. Pick ONE loading affordance per surface.
//
// aria-hidden: the shells are decorative; a route-transition announcement is the
// RouteAnnouncer's job, and the page's own busy state is announced once it mounts.
const DiscoverFeedSkeleton = () => (
  <Box
    aria-hidden="true"
    data-testid="discover-feed-skeleton"
    sx={{
      minHeight: "100vh",
      width: "100%",
      maxWidth: 1280,
      mx: "auto",
      px: { xs: 2, sm: 3 },
      pt: 3,
      boxSizing: "border-box",
    }}
  >
    <Grid container spacing={2}>
      <ExploreCardSkeleton count={12} />
    </Grid>
  </Box>
);

export default DiscoverFeedSkeleton;
